import React from 'react';
import { Navigate } from 'react-router-dom';

import { useAppSelector } from '../../redux/hooks';
import { VENUE_MANUAL_TAGS } from '../../utils/venue-tags';

type Props = {
  children: React.ReactNode;
};

export const BrandRoute: React.FC<Props> = ({ children }) => {
  const { tags: venueTags } = useAppSelector((state) => state.venue.value) || {};
  const isLoading = useAppSelector((state) => state.venue.isLoading) || {};
  const { subscription, isLoading: subscriptionLoading } = useAppSelector(
    (state) => state.subscription.value,
  );

  if (isLoading && subscriptionLoading) return null;

  return venueTags && venueTags?.includes(VENUE_MANUAL_TAGS.BrandPlans) && !subscription?.sku ? (
    <Navigate to='/plans' />
  ) : (
    children
  );
};
